import { ITaxonomyField, OfferType } from '@jumpstart/core';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { db } from '../../core/firebase';
import { formStyles } from '../event-creation/styles';
import { IOrganizationEnhanced } from './utils';
import BusinessSearch from './widgets/BusinessSearch';
import { collection, query, where, Query } from "firebase/firestore";

export default function BusinessCreationPage() {
  const [taxonomies]= useCollectionData<ITaxonomyField>(query(collection(db, 'scout9-taxonomy'), where('type', '==', OfferType.SERVICE_LINE)) as Query<ITaxonomyField>);
  const [taxonomy, setTaxonomy] = useState<ITaxonomyField | null>(null);
  const [created, setCreated] = useState<IOrganizationEnhanced | null>(null);

  const handleChange = () => {
    console.log('Changed');
  };

  return (
    <Grid
      container
      direction="column"
    >
      {taxonomies && <Autocomplete
        id="combo-box-demo"
        options={taxonomies}
        getOptionLabel={(option) => option.name}
        style={{ width: '100%' }}
        onChange={(event: any, newValue: ITaxonomyField | null) => {
          setTaxonomy(newValue);
        }}
        renderInput={(params) => <TextField {...params} sx={formStyles.input} label="Business Type" variant="outlined"/>}
      />}
      {taxonomy && <BusinessSearch
        position={null}
        taxonomy={taxonomy}
        error={false}
        helperText="Type a business, click it and I will copy it into Scout9 as an organization"
        onChange={handleChange}
        onCreated={setCreated}
      />}

      <Snackbar open={!!created} autoHideDuration={6000} onClose={() => setCreated(null)}>
        <Alert onClose={() => setCreated(null)} severity="success">
          Created "scout9-organization/{created ? created.id : ''}" - {created ? created.name : ''}
        </Alert>
      </Snackbar>
    </Grid>
  );
}
